/**
 * Created by Mark on 18/04/2017.
 */


import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import ListItem from '../components/lists/list-item.js';
import Wizard from '../components/wizard/wizard.js';
import Steps  from '../components/wizard/assignment-steps';
import {Breadcrumb} from 'react-bootstrap';
import { FormattedMessage , FormattedDate } from 'react-intl';
import AssignmentServices from '../services/assignment-services.js';
import AssignmentStore from '../store/assignment-store.js';
import AboutHomework  from '../components/wizard/assignment-steps/about-assignments.js';
import AssignAssignments from '../components/wizard/assignment-steps/assign-assignments.js';
import Save from '../components/wizard/assignment-steps/duplicate-save-assignment.js';

export default class ClassesWizardComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {};
    }

    componentDidMount() {
        AssignmentServices.getAssignment(this.props.params.assignmentID)
    }

    componentWillMount(){
        AssignmentStore.on("GET_HOMEWORK_DETAIL" , () => {
            var assignment = AssignmentStore.getHomework(this.props.params.assignmentID);
            this.setState({data:{
                uid:this.props.params.assignmentID,
                className:String(assignment.name) + ' 1',
                tests:assignment.tests,
                classes:assignment.classes,
                students:assignment.students
            }});
        });
    }

    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item href={"#/assignment/management/"}>
                <FormattedMessage id={ 'ui-00' } defaultMessage={ 'Assignment History' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item href={"#/assignment/overview/"+this.props.params.assignmentID}>
                <FormattedMessage id={ 'ui-00' } defaultMessage={ this.state.data.className }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-00' } defaultMessage={ 'Duplicate Assignment' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    render(){

        if(!this.state.data) return <Layout/>;

        return (<Layout>{this.getBreadCrumb()} <Wizard data={this.state.data} stepsNavigation={true} steps={[AboutHomework , AssignAssignments , Save]} /></Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/assignment-duplicate.js